import InputLabel from '@material-ui/core/InputLabel'
import Grid from 'components/Grid'
import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const Wrapper = styled.div`
  width: 100%;
`
export const NomeSecao = styled.h1`
  ${({ theme }) => css`
    color: ${theme.colors.black};
    font-weight: ${theme.font.extraBold};
    font-size: ${theme.font.sizes.medium};
  `}
  margin-bottom: 24px;
`
export const SecaoOpcional = styled.span`
  ${({ theme }) => css`
    color: ${theme.colors.gray};
    font-size: ${theme.font.sizes.small};
    font-weight: ${theme.font.normal};
  `}
  margin-left: 6px;
`

export const NomeSubSessao = styled.h1`
  ${({ theme }) => css`
    color: ${theme.colors.darkGray};
    font-weight: ${theme.font.bold};
    font-size: ${theme.font.sizes.medium};
  `}
  margin-bottom: 12px;
`

export const Label = styled(InputLabel)`
  margin-bottom: 8px;
  min-width: 352px;
`

export const GridCustomizado = styled(Grid)`
  ${media.lessThan('large')`
    display: flex;
    flex-wrap: wrap;
    grid-gap: 24px 56px;
    margin: 0 0 56px 0;
  `}
`
